import { useEffect, useState } from "react";
import { API_END_POINT } from "../../../constants";
import { Button, Modal } from "react-bootstrap";
import '@progress/kendo-theme-default/dist/all.css';
import '../../../components/Style/OrderStyle.css';
import React from "react";
import { Product, Receipt } from "../../../models/transaction/orderdroppingpointproduct-model";
import { useGetPaymentMode } from "../../../apiclient/common/useGetPaymentModeApi";
import { useLocation } from "react-router-dom";
import { OrderHistory } from "../../../models/transaction/orderhistory-model";
import EditIcon from "../../../assets/images/edit";
import { getDataWithToken, getEndPoint, postData } from "../../../Utils/network.client";
import DatePicker from "react-datepicker";
import dayjs from "dayjs";
import { formatDate } from "@progress/kendo-intl";
import DeleteIcon from "../../../assets/images/delete";
import ZoneCounterModel from "../../../models/transaction/zonecounter-model";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";

interface AgentOrderLitreEditProps {
    data: ZoneCounterModel;
    onClose?: () => void;
    setActivePage: (page: "list" | "entry") => void;
}

const AgentLiterOrderEntry: React.FC<AgentOrderLitreEditProps> = ({ data, setActivePage }) => {
    const location = useLocation();
    const agentData = data;

    let orderZoneId = agentData.zoneId;
    let orderCounterId = agentData.counterId;

    const [loadingDetails, setLoadingDetails] = useState<boolean>(false);
    const [droppingPointCode, setdroppingPointCode] = useState<string>("");
    const [totalAmount, setTotalAmount] = useState<number>(0);
    const [showModal, setShowModal] = useState(false);
    const [showGrid, setShowGrid] = useState(false);
    const [isGetClicked, setIsGetClicked] = useState(false);
    const [droppingPointData, setDroppingPointData] = useState<string>('');
    const [modeOfPayment, setModeOfPayment] = useState<number>(0);
    const [reference, setReference] = useState('');
    const [receivedAmount, setReceivedAmount] = useState('');
    const [receiptId, setReceiptId] = useState<number>(0);
    const [droppingPointId, setdroppingPointId] = useState(0);
    const [agentId, setAgentId] = useState(0);
    const [categoryId, setCategoryId] = useState(0);
    const [zoneId, setZoneId] = useState(0);
    const [routeId, setRouteId] = useState(0);
    const [counterId, setCounterId] = useState(0);
    const [orderNumber, setorderNumber] = useState(0);
    const [isAllowCredit, setisAllowCredit] = useState(false);
    const [isDespatched, setisDespatched] = useState(false);
    const [discountAmount, setdiscountAmount] = useState(0);
    const [fetchedProductList, setFetchedProductList] = useState<Product[]>([]);
    const [orderHistoryList, setOrderHistoryList] = useState<OrderHistory[]>([]);
    const [selectedItem, setSelectedItem] = useState<any>(null);
    const [receiptList, setReceiptList] = useState<Receipt[]>([]);
    const [modalTitle, setModalTitle] = useState<string>("");
    const [modalLine1, setModalLine1] = useState("");
    const [modalLine2, setModalLine2] = useState("");
    const [isUpdateMode, setIsUpdateMode] = useState(false);
    const [isDeleteMode, setIsDeleteMode] = useState(false);
    const [modePayment, setmodePaymentData] = useState<{ value: string; label: string }[]>([]);

    const { data: fetchedModePayment } = useGetPaymentMode();

    useEffect(() => {
        if (fetchedModePayment) {
            const mappedmodepayment = fetchedModePayment.map((modepayment: any) => ({
                value: modepayment.id,
                label: modepayment.name,
            }));
            setmodePaymentData(mappedmodepayment);
        }
    }, [fetchedModePayment]);

    const [orderDate, setOrderDate] = useState<Date>(new Date(dayjs().add(0, "months").format("MM/DD/YYYY")));
    const [orderDate2, setOrderDate2] = useState<string>("");
    const [deliveryDate, setDeliveryDate] = useState<Date>(new Date(dayjs().add(1, "days").format("MM/DD/YYYY")));
    const [deliveryDate2, setDeliveryDate2] = useState<string>("");

    const handleDateChange = (value: any) => {
        const day = value.getDate().toString().padStart(2, '0');
        const month = value.toLocaleString('default', { month: 'short' }).toUpperCase();
        const year = value.getFullYear();
        const formattedDate = new Date(`${year}-${month}-${day}`);
        setOrderDate(formattedDate);
    };

    const handleDateChanges = (value: any) => {
        const day = value.getDate().toString().padStart(2, '0');
        const month = value.toLocaleString('default', { month: 'short' }).toUpperCase();
        const year = value.getFullYear();
        const formattedDate2 = new Date(`${year}-${month}-${day}`);
        setDeliveryDate(formattedDate2);
    };

    useEffect(() => {
        if (orderDate) {
            const formattedDate1 = dayjs(orderDate).format('ddd MMM DD YYYY ');
            setOrderDate2(formattedDate1);
            getOrderHistoryList(formattedDate1);
        }
        if (deliveryDate) {
            const formattedDate2 = dayjs(deliveryDate).format('ddd MMM DD YYYY ');
            setDeliveryDate2(formattedDate2);
        }
    }, [orderDate, deliveryDate]);

    const handleGetButtonClick = async () => {
        if (droppingPointCode && orderDate2) {
            setLoadingDetails(true);
            try {
                setOrderDate2(orderDate2);
                setdroppingPointCode(droppingPointCode);
                await fetchData(droppingPointCode, orderDate2);
            } catch (error) {
                console.error("Error fetching product price details:", error);
            } finally {
                setLoadingDetails(false);
            }
        } else {
            alert("Please select a droppingpoint");
        }
    };

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        if (name === 'droppingPointCode') {
            setdroppingPointCode(value);
        } else if (name === 'reference') {
            setReference(value);
        } else if (name === 'receivedAmount') {
            setReceivedAmount(value);
        }
    };

    const fetchData = async (droppingPointCode: string, orderDate2: string) => {
        const getProductUrl = getEndPoint(API_END_POINT.ORDER) + `/api/OrderMain/GetProductsByDroppingPointCode/${droppingPointCode}/${orderDate2}`;
        try {
            const response = await getDataWithToken<any>(getProductUrl);
            const product = response?.data?.result?.product || [];
            const receipt = response?.data?.result?.receipt || [];
            setReceiptList(receipt);

            if (product.length) {
                const droppingPoint = product[0];
                const droppingPointId = droppingPoint?.droppingpointId;
                const credit = droppingPoint?.isAllowCredit;

                setdroppingPointId(droppingPointId);
                setisAllowCredit(credit);
                setDroppingPointData(
                    `Booth: ${droppingPoint.droppingPointCode} - ${droppingPoint.droppingPointName}       Route: Mor:${droppingPoint.morRouteName} / Eve:${droppingPoint.eveRouteName}\nAgent: ${droppingPoint.agentCode} - ${droppingPoint.agentName}    Category: ${droppingPoint.categoryName}  Zone: ${droppingPoint.zoneName}`
                );

                setFetchedProductList(product.map((item: any) => ({
                    ...item,
                    inEdit: true,
                    amount: (Number(item.morningQty) + Number(item.eveningQty)) * Number(item.baseRate),
                })));

                calculateTotalAmount(product);

                if (receipt[0]?.orderAmount) {
                    setTotalAmount(receipt[0]?.orderAmount);
                } else {
                    setTotalAmount(0.00);
                }
                setShowGrid(true);
                setIsGetClicked(true);
            } else {
                setShowGrid(false);
                setDroppingPointData('');
                setModeOfPayment(0);
                setReference('');
                setReceivedAmount('');
                setTotalAmount(0);
                alert("No Data Found");
            }

            if (receipt.length) {
                setModeOfPayment(receipt[0]?.paymentModeId);
                setReference(receipt[0]?.reference);
                setReceivedAmount(receipt[0]?.receivedAmount);
                setReceiptId(receipt[0]?.receiptId);
            } else {
                setModeOfPayment(0);
                setReference('');
                setReceivedAmount('');
                setReceiptId(0);
            }
            if (isAllowCredit) {
                setModeOfPayment(5);
            } else if (receipt.length === 0) {
                setModeOfPayment(0);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            setShowGrid(false);
        }
    };

    const handleConfirmOrder = () => {
        setIsUpdateMode(false);
        const isValidOrder = fetchedProductList.some(product =>
            product.morningQty > 0 || product.eveningQty > 0
        );
        if (isValidOrder) {
            if (isAllowCredit === false) {
                if (modeOfPayment) {
                    if (reference === "" && modeOfPayment === 1 || reference) {
                        if (parseFloat(receivedAmount) >= totalAmount) {
                            setLoadingDetails(false);
                            setShowModal(true);
                            setModalTitle("Order Confirmation");
                            setModalLine1("Are you sure you want to confirm the order?");
                        } else {
                            alert("Please check the Received Amount less than totalAmount ");
                        }
                    } else {
                        alert("Please Select a Reference");
                    }
                } else {
                    alert("Please select a Payment Mode");
                }
            } else {
                setLoadingDetails(false);
                setShowModal(true);
                setModalTitle("Order Confirmation");
                setModalLine1("Are you sure you want to confirm the order?");
            }
        } else {
            alert("Please Select Morning Quantity or Evening Quantity");
            setdroppingPointCode('');
            setDroppingPointData('');
        }
    };

    const getOrderHistoryList = async (formattedDate: string) => {
        try {
            const getOrderHistoryUrl = getEndPoint(API_END_POINT.ORDER) + `/api/OrderMain/GetOrderHistoryList/${formattedDate}/${agentData.zoneId}/${agentData.counterId}/${1}/${2}`;
            const response = await getDataWithToken<any>(getOrderHistoryUrl);
            const orderHistory = response?.data?.result || [];
            setOrderHistoryList(orderHistory);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const handleModedropdownChange = (event: { target: { value: any; }; }) => {
        setModeOfPayment(event.target.value);
    };

    const calculateTotalAmount = (data: any[]) => {
        const total = data.reduce((sum, item) => {
            const amount = parseFloat(item.amount);
            return sum + (isNaN(amount) ? 0 : amount);
        }, 0);
        if (total) {
            setTotalAmount(total);
            if (isAllowCredit === false) {
                setReceivedAmount(total.toFixed(2));
            } else {
                setReceivedAmount('0');
            }
        } else {
            setTotalAmount(0.00);
        }
    };

    const totalOrderAmount = orderHistoryList.reduce((sum, item) => sum + item.receiptAmount, 0).toFixed(2);
    const orderCount = orderHistoryList.length;

    const handleEdit = (item: any) => {
        setSelectedItem(item);
        setShowModal(true);
        setIsDeleteMode(false);
        const isUpdate = item.droppingPointCode !== 0;
        setIsUpdateMode(isUpdate);
        if (isUpdate) {
            setModalTitle("Edit Order");
            setModalLine1("Do you want to edit this order?");
        }
        setdroppingPointCode(item.droppingPointCode);
        setOrderDate2(item.receiptDate);
        if (item.deliveryDate) {
            const parsedDate = dayjs(item.deliveryDate, "ddd MMM DD YYYY").toDate();
            setDeliveryDate(parsedDate);
            setDeliveryDate2(item.deliveryDate);
        }
    };

    const handleOkOrder = async () => {
        if (!selectedItem) return;
        setLoadingDetails(true);
        setShowModal(false);
        try {
            await fetchData(selectedItem.droppingPointCode, selectedItem.receiptDate);
        } catch (error) {
            console.error("Error during proceed:", error);
        } finally {
            setLoadingDetails(false);
        }
    };

    const handleDelete = async (item: any) => {
        setIsUpdateMode(false);
        setIsDeleteMode(true);
        setSelectedItem(item);
        setModalTitle("Delete Confirmation");
        setModalLine1("Are you sure you want to delete?");
        setShowModal(true);
    };

    const handleDeleteOkOrder = async () => {
        if (!selectedItem) return;
        const getDeleteOrderUrl = getEndPoint(API_END_POINT.ORDER) + `/api/OrderMain/DeleteAgentOrder/${selectedItem.receiptId}`;
        try {
            const response = await getDataWithToken<any>(getDeleteOrderUrl);
            const res = response?.data?.result;
            if (res) {
                alert("Order Deleted Successfully");
                getOrderHistoryList(selectedItem.receiptDate);
                await fetchData(selectedItem.droppingPointCode, selectedItem.receiptDate);
                setIsDeleteMode(false);
                setShowModal(false);
            } else {
                console.error("No order data found.");
            }
        } catch (error) {
            console.error('Error deleting order:', error);
        }
    };

    const handleQtyChange = (e: React.ChangeEvent<HTMLInputElement>, index: number, type: string) => {
        const updatedList = [...fetchedProductList];
        const updatedItem = updatedList[index];

        let value = Number(e.target.value);
        if (isNaN(value) || value < 0) {
            value = 0;
        }
        if (type === 'morningQty') {
            updatedItem.morningQty = value;
        } else if (type === 'eveningQty') {
            updatedItem.eveningQty = value;
        }

        let Liter = 1 / Number(updatedItem.unitQty);
        updatedItem.amount = (Number(updatedItem.morningQty) + Number(updatedItem.eveningQty)) * Number(updatedItem.baseRate) * Liter;
        updatedList[index] = updatedItem;
        setFetchedProductList(updatedList);
        calculateTotalAmount(updatedList);
    };

    const handleRowClick = (event: any) => {
        const updated = fetchedProductList.map((item) =>
            item.productId === event.dataItem.productId
                ? { ...item, inEdit: true }
                : { ...item, inEdit: false }
        );
        setFetchedProductList(updated);
    };

    const handleItemChange = (e: any) => {
        const updated = [...fetchedProductList];
        const index = updated.findIndex((item) => item.productId === e.dataItem.productId);

        if (index !== -1) {
            const field = e.field;
            const value = Number(e.value) >= 0 ? Number(e.value) : 0;
            const currentItem = { ...updated[index], [field]: value };
           
            currentItem.morningQty = field === 'morningQty' ? value/* Math.min(Math.max(Number(value), 0), 9999) */ : Number(currentItem.morningQty) || 0;
            currentItem.eveningQty = field === 'eveningQty' ? value : Number(currentItem.eveningQty) || 0;
            //currentItem.amount = (Number(currentItem.morningQty) + Number(currentItem.eveningQty)) * Number(currentItem.baseRate);
            let Liter = 1 / Number(currentItem.unitQty);
            currentItem.amount = (Number(currentItem.morningQty) + Number(currentItem.eveningQty)) * Number(currentItem.baseRate) || 0 * Liter;
            updated[index] = currentItem;
            setFetchedProductList(updated);
        }
    };

    const handleProceedOrder = async () => {
        setLoadingDetails(true);
        setIsUpdateMode(false);
        try {
            const OrderLine = fetchedProductList.map(product => ({
                productId: product.productId,
                productname: product.productName,
                basicrateperunit: product.baseRate,
                morningquantitypackets: product.morningQty,
                eveningquantitypackets: product.eveningQty,
                amount: product.amount,
                orderline_mid: product.orderLine_MId,
                orderline_eid: product.orderLine_EId,
                ordermain_mid: product.orderMain_MId,
                ordermain_eid: product.orderMain_EId,
                droppingpointid: product.droppingpointId,
                maingroupid: product.mainGroupId,
                subgroupid: product.subGroupId,
                productshortname: product.productShortName,
                morrouteid: product.morRouteId,
                everouteid: product.eveRouteId,
                cgstpercentage: product.cgstPercentage,
                sgstpercentage: product.sgstPercentage,
                igstpercentage: product.igstPercentage,
                cgstrateperunit: product.cgstRate,
                sgstrateperunit: product.sgstRate,
                igstrateperunit: product.igstRate,
                unitqty: product.unitQty,
                unitfactor: product.unitFactor,
                packetpertray: product.packetPerTray,
                orderDate: orderDate2,
                deliveryDate: deliveryDate2,
                orderNumber,
                agentId: product.agentId,
                categoryId: product.categoryId,
                zoneId: orderZoneId,
                routeId: product.routeId,
                counterId: orderCounterId,
                isDespatched,
                orderAmount: totalAmount,
                receivedAmount,
                discountAmount,
                orderMode: 1,
                type: 2
            }));

            const OrderReceipt = {
                receiptId: receiptId,
                paymentmode: modeOfPayment,
                receiptamount: receivedAmount,
                paymenttype: 1,
                counterId: orderCounterId,
                droppingPointId,
                agentId,
                reference: reference,
                receiptDate: orderDate2,
                orderAmount: totalAmount,
                paymentstatus: 1,
                receiptNumber: "REC001"
            };

            const orderRequest = {
                OrderLine,
                OrderReceipt,
            };
            const response = await postData<any>(API_END_POINT.ORDER,
                "OrderMain/SaveOrder",
                "POST",
                "application/json",
                orderRequest,
            );
            if (response.status === 200) {
                alert("Order Confirmed Successfully!");
                setLoadingDetails(false);
                setFetchedProductList(prevProductList =>
                    prevProductList.map(product => ({
                        ...product,
                        morningQty: 0,
                        eveningQty: 0,
                        amount: 0
                    }))
                );
                setModeOfPayment(0);
                setReference('');
                setReceivedAmount('');
                setTotalAmount(0);
                setdroppingPointCode('');
                setDroppingPointData('');
                getOrderHistoryList(orderDate2);
            } else {
                alert("Failed to Confirm the Order.");
            }
        } catch (error: any) {
            if (error.response) {
                console.error("API Response Error:", error.response.data);
            }
        } finally {
            setLoadingDetails(false);
            setShowModal(false);
        }
    };

    const rowRender = (trElement: any, props: any) => {
        const color = props.dataItem.productColor;
        /*   alert(color) */
        const style = color ? { '--input-border': color } : {};
        return React.cloneElement(trElement, { style });
    };

    return (
        <><div className="fade_rule"></div>
            <div className="d-flex justify-content-between mt-4 pt-3 pb-3">
                <div className="d-flex" style={{ marginTop: "-50px", marginLeft: "20px" }}>
                    <div className="me-2" style={{ width: '150px' }}>
                        <label>Order Date</label>
                        <DatePicker
                            name="orderDate"
                            selectsMultiple={true}
                            openToDate={new Date()}
                            className="form-control ms-auto search-right-align calendarBg"
                            value={formatDate(orderDate, "dd-MM-yyyy")}
                            placeholderText="Order"
                            dateFormat={"dd/MM/yyyy"}
                            popperPlacement="bottom-start"
                            portalId="root-portal"
                            onChange={([date]: any) => {
                                setOrderDate(date);
                                handleDateChange(date)
                            }}
                        />
                    </div>
                    <div className="me-2" style={{ width: '150px' }}>
                        <label>Delivery Date</label>
                        <DatePicker
                            name="deliveryDate"
                            selectsMultiple={true}
                            openToDate={new Date()}
                            className="form-control ms-auto search-right-align calendarBg"
                            value={formatDate(deliveryDate, "dd-MM-yyyy")}
                            placeholderText="Delivery"
                            dateFormat={"dd/MM/yyyy"}
                            popperPlacement="bottom-start"
                            portalId="root-portal"
                            onChange={([date]: any) => {
                                setDeliveryDate(date);
                                handleDateChanges(date)
                            }}
                        />
                    </div>
                    <div className="me-2" style={{ width: '110px' }}>
                        <label>Booth</label>
                        <input
                            name="droppingPointCode"
                            value={droppingPointCode}
                            onChange={handleChange}
                            className="boothinput"
                        ></input>
                    </div>
                    <div className="me-2" style={{ width: '110px' }}>
                        <button
                            className="btn btn-primary btn-sm"
                            style={{ height: '36px', marginTop: '20px' }}
                            onClick={handleGetButtonClick}
                        >
                            Get
                        </button>
                    </div>
                    {isGetClicked && (
                        <div className="me-2" style={{ marginTop: '15px', marginLeft: 1 }}>
                            <pre style={{ fontSize: '15px' }}>{droppingPointData}</pre>
                        </div>
                    )}
                </div>
            </div>

            <div className="d-flex justify-content-between mt-4 pt-3 pb-3">
                {/* <div style={{ flex: '0 0 100%' }}> */}
                <div style={{ flex: '0 0 55%', height: 'auto', overflow: 'visible', marginTop: "-43px" }}>
                    {isGetClicked && (
                        <><Grid
                            rowRender={rowRender}
                            // data={fetchedProductList.slice(page.skip, page.skip + page.take)}
                            data={fetchedProductList
                                //.sort((a, b) => a.subGroupId - b.subGroupId)
                                .sort((a, b) => {
                                    // First, sort by mainGroupId
                                    if (a.mainGroupId !== b.mainGroupId) {
                                        //  console.log("Sorting by mainGroupId:", a.mainGroupId - b.mainGroupId);
                                        return a.mainGroupId - b.mainGroupId;
                                    }

                                    // If mainGroupId is the same, then sort by subGroupId
                                    if (a.subGroupId !== b.subGroupId) {
                                        //console.log("Sorting by subGroupId:", a.subGroupId - b.subGroupId);
                                        return a.subGroupId - b.subGroupId;
                                    }

                                    // If both mainGroupId and subGroupId are the same, sort by unitQty
                                    // console.log("Sorting by unitQty:", a.unitQty - b.unitQty);
                                    return a.unitQty - b.unitQty;
                                })}

                            style={{ height: 'auto' }}
                            editField='inEdit'
                            dataItemKey='productId'
                            // pageable={{ pageSizes: [10, 20, 50, 100] }}
                            //skip={page.skip}
                            // take={page.take}
                            total={fetchedProductList?.length}
                           // onPageChange={(e) => setPage({ skip: e.page.skip, take: e.page.take })}
                            onItemChange={handleItemChange}
                           // onRowClick={handleRowClick}
                        >
                            <Column field="code" title="Code" width="60px" editable={false} />
                            <Column field="productName" title="Product Name" width="200px" editable={false} />
                            <Column field='baseRate' title='Rate' width="130px" editable={false}
                                format="{0:n2}" className="right-align" />
                            <Column
                                field="morningQty"
                                title="Mor Qty/Pkts"
                                width="100px"
                                editable={true}
                                editor="text"

                            />
                            <Column field='eveningQty' title='Eve Qty /Pkts' width="100px" editable={true} className="right-align"
                                editor='text' format="{0:n3}"
                            />
                            <Column
                                field="amount"
                                title="Amount"
                                width="135px"
                                editable={false}
                                editor='text'
                                className="right-align"
                                format="{0:n2}"
                                // cell={(props) => <td className="right-align">{(parseFloat(props.dataItem.amount) || 0).toFixed(2)}</td>}
                                footerCell={() => (
                                    <td className="footer-align">
                                        {fetchedProductList.reduce((sum, item) => sum + (Number(item.amount) || 0), 0).toFixed(2)}
                                    </td>
                                )} />
                        </Grid>
                            <div className="d-flex justify-content-between mt-4 pt-3 pb-3">
                                <div className="d-flex" style={{ marginTop: "-20px", marginLeft: "20px" }}>
                                    <div className="me-2" style={{ width: '150px' }}>
                                        <label>Payment Mode</label>
                                        <select
                                            value={modeOfPayment}
                                            onChange={handleModedropdownChange}
                                            className="boothinput"
                                        >
                                            <option value="">Please Select</option>
                                            {modePayment.map((option) => (
                                                <option key={option.label} value={option.value}>
                                                    {option.label}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="me-2" style={{ width: '160px' }}>
                                        <label>Reference</label>
                                        <input
                                            name="reference"
                                            className="boothinput"
                                            value={reference}
                                            onChange={handleChange}
                                        ></input>
                                    </div>
                                    <div className="me-2" style={{ width: '180px' }}>
                                        <label>Received Amount</label>
                                        <input
                                            name="receivedAmount"
                                            value={receivedAmount}
                                            onChange={handleChange}
                                            className="boothinput"
                                        ></input>
                                    </div>
                                    <div className="me-2" style={{ marginTop: 15 }}>
                                        <Button className="btnOrderStyle" onClick={handleConfirmOrder}>
                                            Confirm Order
                                        </Button>
                                    </div>
                                </div>
                            </div></>
                    )}

                </div>
                <div style={{ flex: '0 0 40%', /* minHeight: '280px' */ height: 'auto', marginRight: 30, marginTop: "-43px" }}>
                    <div>
                        <div className="order-container">
                            <div className="summary-rows">
                                <div><b>{agentData?.name || 'Loading...'}</b></div>
                            </div>
                            <div className="summary-rows">
                                <div><span>{orderDate2}</span> <span>Total Amount - </span><b> ₹{totalOrderAmount}</b>                                <span>Count:</span> {orderCount} </div>
                            </div>
                            {/* Horizontal Line Divider */}
                            <hr className="divider" />

                            {/* Table displaying order details */}
                            <table className="order-history-table">
                                <thead>
                                    <tr>
                                        <th>Date</th>
                                        <th>Booth</th>
                                        <th style={{ textAlign: 'right' }}>Amount</th>
                                        <th></th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {orderHistoryList.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.receiptDate}</td>
                                            <td>{item.droppingPointCode} - {item.droppingPointName}</td>
                                            {/* <td>{item.droppingPointName}</td> */}
                                            <td>₹{item.receiptAmount.toFixed(2)}</td>
                                            <td> <button style={{ width: "5px" }}
                                                className="action-btns k-grid-edit-command"
                                                onClick={() => handleEdit(item)}
                                            >
                                                <EditIcon></EditIcon>{' '}

                                            </button>
                                                <button style={{ width: "5px" }}
                                                    className="action-btns k-grid-edit-command"
                                                    onClick={() => handleDelete(item)}
                                                >
                                                    <DeleteIcon></DeleteIcon>{' '}
                                                    {/* <img src={iconEdit} alt="edit" title="Edit" /> */}
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <Modal style={{ alignContent: "center" }} show={showModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    {/*   <Modal.Title>Order Confirmation</Modal.Title> */}
                    <Modal.Title>{modalTitle}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h6>{modalLine1}</h6>
                    <h6>{modalLine2}</h6>
                    {!isUpdateMode && !isDeleteMode && (
                        <p>Total Amount: ₹ {receivedAmount}</p>
                    )}
                    {/*  <p>Total Amount: ₹ {receivedAmount}</p> */}
                </Modal.Body>
                <Modal.Footer>

                    {isDeleteMode ? (
                        <>
                            <Button variant="secondary" onClick={handleCloseModal}>Cancel</Button>
                            <Button variant="danger" onClick={handleDeleteOkOrder}>Delete</Button>
                        </>
                    ) : isUpdateMode ? (
                        <Button variant="primary" onClick={handleOkOrder}>OK</Button>
                    ) : (
                        <>
                            <Button variant="secondary" onClick={handleCloseModal}>Back</Button>
                            <Button variant="primary" onClick={handleProceedOrder}>
                                {loadingDetails ? (
                                    <>
                                        <span className="spinner-inline" /> Processing...
                                    </>
                                ) : (
                                    'Proceed'
                                )}
                            </Button>
                        </>
                    )}
                </Modal.Footer>
            </Modal>
            {/* Back Button */}
            <div className="mt-3" style={{ marginLeft: '20px' }}>
                <button
                    className="btn btn-primary btn-sm"
                    style={{ height: '36px', marginTop: '20px' }}
                    onClick={() => setActivePage("list")}  // Changed from "agentliterorderpage" to "list"
                >
                    ← Back
                </button>
            </div>
        </>
    );
};
export default AgentLiterOrderEntry;

